import React from "react";
import { ErrorPage } from "./pages";
import { useLocation } from 'react-router-dom';

class ErrorBoundaryInner extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidUpdate(prevProps) {
    // If navigation changed, clear the error so the new route can render
    if (this.props.location && prevProps.location && this.props.location.pathname !== prevProps.location.pathname) {
      if (this.state.hasError) {
        this.setState({ hasError: false });
      }
    }
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage onReset={() => this.setState({ hasError: false })} />;
    }

    return this.props.children; 
  }
}

// Functional wrapper so we can access hooks (location) and pass into the class
export default function ErrorBoundary(props) {
  const location = useLocation();
  return <ErrorBoundaryInner {...props} location={location} />;
}
